<template>
	<div>
		<v-card-title>
			<h2>Opinie mojej placówki</h2>
		</v-card-title>
		<agency-evaluation-table/>
	</div>
</template>

<script>
	import AgencyEvaluationTable from "./AgencyEvaluationTable";

	export default {
		name: "AgencyEvaluationList",
		components: {AgencyEvaluationTable}
	};
</script>

<style scoped>

</style>